import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ErrorHandlerService } from '@examdojo/error-handling';
import { mapToVoid } from '@examdojo/core/rxjs';
import { EMPTY, take } from 'rxjs';
import { ClassService } from './class.service';

export const classResolver: ResolveFn<void> = () => {
  const classService = inject(ClassService);
  const errorHandlerService = inject(ErrorHandlerService);

  return classService.fetchClasses().pipe(
    errorHandlerService.catchHttpErrors(() => EMPTY),
    take(1),
    mapToVoid(),
  );
};
